/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */

import { Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { Response, User } from '@app/models';
import { AdminUserAccountsService } from './user-accounts.service';

@Injectable()
export class AdminUserResolverService implements Resolve<Response> {
  user: User;

  constructor(private adminUserAccountsService: AdminUserAccountsService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    if (route.params.uuid) {
      return this.adminUserAccountsService.getUsers(route.params.uuid).pipe(
        take(1),
        map(res => {
          this.user = res['data'];
          // console.log('Sales Associates Resolver:', this.associate);
          return this.user;
        })
      );
    } else {
      return false; 
    }
  }
}
